import { useStore } from 'hooks';
import { useEffect } from 'react';
import { Qual } from 'types';
import { useShallow } from 'zustand/react/shallow';
import { getCurrentProfile } from '@updater/identity';
import { MicrositeList } from 'config/microsites';

const qualOnLoadMap = MicrositeList.reduce((acc, config) => {
  if (config.qualOnLoad) {
    const { hostname, ...qualDefaults } = config.qualOnLoad;
    acc[hostname] = { ...qualDefaults, microsite: config.micrositeCode };
  }
  return acc;
}, {});

export function useQual(): Qual {
  const { qual, setQual } = useStore(
    useShallow((store) => ({ qual: store.qual, setQual: store.setQual }))
  );

  useEffect(() => {
    const isEmptyQualObject = Object.keys(qual).length === 0;
    if (typeof window !== 'undefined' && isEmptyQualObject) {
      // Remove "staging-" prefix
      const hostname = window.location.hostname?.replace(/^staging-/, '');

      if (qualOnLoadMap[hostname]) {
        setQual({
          ...qualOnLoadMap[hostname],
          uuid: getCurrentProfile()?.updUuid,
        });
      }
    } else if (!isEmptyQualObject && !qual.uuid) {
      const uuid = getCurrentProfile()?.updUuid;
      // Unreachable: initIdentity() runs at module scope in _app, before any
      // render, so the profile always has a uuid by now. Kept because writing a
      // still-uuid-less qual would re-enter this same branch on the next render
      // and loop forever (COREX-1896). ProviderWrapper renders the NO_UUID error
      // for a qual that genuinely has no uuid.
      if (!uuid) return;

      setQual({ ...qual, uuid });
    }
  }, [qual, setQual]);

  return qual;
}
